export default "__VITE_ASSET__Dp2lP3M___"